import { ServiceName } from '@deltasierra/integrations-integration-types';
import { assertNever, pick } from '../common';
import { Platform } from '../platform/Platform';
import { IntegrationId } from './Integration';
import {
    AgencyIntegrationDescriptionBase,
    ClientIntegrationDescriptionBase,
    LocationIntegrationDescriptionBase,
} from './IntegrationDescriptionBase';
import { IntegrationIdDescription } from './IntegrationIdDescription';

export interface IntegrationDescriptionBase {
    serviceName: ServiceName;
    platform: Platform;
    integrationId: IntegrationId;
}
export interface AgencyIntegrationDescription extends IntegrationDescriptionBase, AgencyIntegrationDescriptionBase {}
export interface ClientIntegrationDescription extends IntegrationDescriptionBase, ClientIntegrationDescriptionBase {}
export interface LocationIntegrationDescription
    extends IntegrationDescriptionBase,
        LocationIntegrationDescriptionBase {}

export type IntegrationDescription =
    | AgencyIntegrationDescription
    | ClientIntegrationDescription
    | LocationIntegrationDescription;

export function fromIntegrationIdDescription(
    integrationIdDescription: IntegrationIdDescription,
    platform: Platform,
): IntegrationDescription {
    if (platform.id !== integrationIdDescription.platformId) {
        throw new Error('The platform id does not match and therefore cannot be converted');
    }

    switch (integrationIdDescription.level) {
        case 'agency':
            return {
                ...pick(integrationIdDescription, 'id', 'level', 'integrationId'),
                platform,
                serviceName: platform.name,
            };
        case 'client':
            return {
                ...pick(integrationIdDescription, 'id', 'level', 'integrationId'),
                platform,
                serviceName: platform.name,
            };
        case 'location':
            return {
                ...pick(integrationIdDescription, 'id', 'level', 'integrationId'),
                platform,
                serviceName: platform.name,
            };
        default:
            return assertNever(integrationIdDescription);
    }
}
